import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import Table from "../../components/table/Table";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import ActionEditButton from "../../components/UIComponent/ActionTableComponent/ActionEditButton";
import ActionDeleteButton from "../../components/UIComponent/ActionTableComponent/ActionDeleteButton";
import { encryptAES } from "../../utils/Encryption";
import DtsmeServices from "../../services/axiosServices/apiServices/DtsmeServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { CommonValidationMessages } from "../../utils/Messages";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { saveAs } from "file-saver";
import CommonServices from "../../services/axiosServices/apiServices/CommonServices";
import { IframeView } from "ckeditor5";
import moment from "moment";
export default class RoadMapReports extends Component {
    constructor(props) {
        super(props);
        this.dtsmeServices = new DtsmeServices();
        this.swalServices = new SwalServices();
        this.CommonServices = new CommonServices()
        this.state = {
            DTSMEPurchaseReportRequest: {
                startDate: "",
                endDate: "",
            },
            isLoading: false,
            redirect: null,
            pagination: {
                orderByColumn: "",
                orderFlag: 0,
                pageNo: 1,
                pageSize: 10,
                searchText: "",
                requestDate: "",
                statusId: 0
            },
            validationRule: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "Start date for transaction report"),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "End date for transaction report"),
                    },
                    {
                        type: "minEndDate",
                        minEndDate: "startDate",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "greater end date")
                    }
                ],
            },
            dtasmeRoadMapCompanyList: [],
            totalResultes: 0,
            councilIndex: 0,
        }
    }
    validateField = (key) => {
        const newValidState = validate(
            key,
            this.state.DTSMEPurchaseReportRequest,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
    };

    isValidateAllFields = () => {
        const newValidState = isValidForm(
            this.state.DTSMEPurchaseReportRequest,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === 'startDate') {
            let date = this.state.DTSMEPurchaseReportRequest
            date.startDate = value
            this.setState({ startDate: date })
        }
        if (name === 'endDate') {
            let date = this.state.DTSMEPurchaseReportRequest
            date.endDate = value
            this.setState({ endDate: date })
        }
    }

    componentDidMount() {
        this.getAllDTSMERoadMapReports()
    }

    getAllDTSMERoadMapReports = (pagination = this.state.pagination) => {
        this.setState({ isLoading: true });
        this.dtsmeServices.getAllDTSMERoadMapReports(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                const formattedList = response.responseItem.responseContent.itemList.map(item => ({
                    ...item,
                    generatedDate: item.generatedDate
                        ? moment(item.generatedDate).format("yyyy-MM-DD") 
                        : ''
                }));

                this.setState({ totalResultes: response.responseItem.responseContent.totalCount, dtasmeRoadMapCompanyList: formattedList });
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
        })
    }

    // Serach By Company Name
    searchByName = (value, identity) => {
        let detail = this.state.pagination;
        if (identity === "Name") {
            detail.pageNo = 1;
            detail.pageSize = 10;
            detail.searchText = value;
            this.setState({ pagination: { ...detail } });
        }
    }

    // Handle pagination Method 
    setPagination = (newPagination) => {
        this.setState({ pagination: newPagination }, () => {
            this.getAllDTSMERoadMapReports(newPagination);
        });
    };



    GetDTSMERoadMapReportDownload = (roadMapReportPath) => {
        this.setState({ isLoading: true });
        const fileName = roadMapReportPath?.split('\\').pop();
        const type = "dt-sme roadMap";
        let request = [type , fileName ]
        this.CommonServices.getDTSMERoadMapReportDownload(request).then((response) => {
            if(response.status === 200 && response.data != null){
                if (response.data?.type === "application/pdf") {
                    let blob = new Blob([response.data])
                    saveAs(blob, `DTSME RoadMapReport` + ".pdf");
                    this.setState({ isLoading: false });
                    this.swalServices.Success("DTSME Roadmap Downloaded Successfully!");
                }
            }else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
        })
    }


    // Action Edit and Delete Method
    actions = (element, index, value) => {
        if (element !== "roadMapReportPath") return null ;
        const companyList = this.state.dtasmeRoadMapCompanyList;

        // Index ke basis pe item nikaal lo
        const item = companyList?.[index];

        const roadMapReportPath = item?.roadMapReportPath;

         return (   <td>
            <ActionContainer>
                <h2 className='ml-2 tool-tip-txt underline text-[#81a3b8] cursor-pointer' onClick={() => this.GetDTSMERoadMapReportDownload(roadMapReportPath)}
                >Download</h2>
            </ActionContainer>
        </td>
        )
    }





    render() {
        if (this.state.redirect != null) {
            return <Navigate to={this.state.redirect} state={this.state.getResourcePagesList} />;
        }
        return (
            <>
                <div className="main-body-section">

                    <div className="custom-card shadow-lg">
                        <div className="filter-info grid grid-cols-12 gap-6">
                            <div className="col-span-12">
                                <div className="grid grid-cols-12 gap-6">
                                    <div className="filter-types xl:col-span-4 lg:col-span-6 col-span-12 pr-12">
                                        <label
                                            className="filter-lable block text-xl font-medium  mb-1 theme-color min-h-30"
                                            htmlFor="default"
                                        >
                                            Name
                                        </label>
                                        <input
                                            id="searchText"
                                            name="searchText"
                                            className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                            type="text"
                                            onChange={(event) => this.searchByName(event.target.value, "Name")}
                                        />
                                    </div>
                                    <div className="xl:col-span-2 lg:col-span-6 col-span-12">
                                        <div className=" patner-search flex items-center justify-end pt-8">
                                            <div className="search">
                                                <button
                                                    className="btn btn-red text-xl text-white font-bold"
                                                    onClick={() => { this.getAllDTSMERoadMapReports(); }}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <main className="pb-10 pt-8">
                        <div className="w-full mx-auto">
                            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                                <div className="mb-4 sm:mb-0">
                                    <h1 className="text-3xl md:text-4xl theme-color font-bold">
                                        {`Total:${this.state.totalResultes}`}
                                    </h1>
                                </div>
                            </div>
                            <div className="relative">
                                <div>
                                    <div className=" mt-6">
                                        <Table
                                            columns={[
                                                { name: "generatedDate", title: "Generated Date", },
                                                { name: "organizationName", title: "Organization Name" },
                                                { name: "roadMapReportPath", title: "Action" },
                                            ]}
                                            pagination={this.state.pagination}
                                            rows={this.state.dtasmeRoadMapCompanyList}
                                            sortingColumns={[""]}
                                            isLoading={this.state.isLoading}
                                            totalResultes={this.state.totalResultes}
                                            totalCount={this.state.totalResultes}
                                            setPagination={this.setPagination.bind(this)}

                                            customScope={[
                                                {
                                                    column: "roadMapReportPath",
                                                    renderTableData: this.actions.bind(this),
                                                },
                                            ]}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </>
        )
    }
}
